/*
Convenience module for 3rd party integrations.
*/

import config from 'modules-core/config'
import log from 'modules-core/log'
import syrinscape from "app/common/syrinscape"
import { postMessageSystem } from 'modules-core/postMessageSystem'

const logger = log.getLogger('integration')

export function createIntegration() {
	logger.info('createIntegration()')
	return {
		requestAuthToken(name: string) {
			name ??= new URL(window.location.href).hostname
			const url = `${config.httpProtocol}://${config.httpHostname}/account/auth-token/?post_message_token=${config.postMessageToken}&integration_name=${name}`
			const width = 600
			const height = 800
			const left = (screen.width / 2) - (width / 2)
			const top = (screen.height / 2) - (height / 2)
			const options = `width=${width},height=${height},left=${left},top=${top},popup`
			window.open(url, "Authorize Integration | Syrinscape", options)
		},

		sendAuthToken(token: string) {
			postMessageSystem.sendMessage("syrinscape.setToken", { token })
		},

		get sessionIdUrl() {
			const prefix = `${config.httpProtocol}://app.${config.httpHostname}`
			if (config.sessionId) {
				return `${prefix}/${config.sessionId}`
			} else {
				return prefix
			}
		},

		get gameMasterInterfaceUrl() {
			return `${this.sessionIdUrl}/gm/`
		},

		launchAsGameMaster() {
			window.open(this.gameMasterInterfaceUrl, "Player | Syrinscape", "popup")
		},

		launchAsPlayer() {
			window.open(this.playerInterfaceUrl, "Player | Syrinscape", "width=400,height=400,popup,scrollbars=no")
		},

		learnMore() {
			const url = `${config.httpProtocol}://${config.httpHostname}/integrations/${window.location.hostname}/`
			logger.info(`learnMore(): ${url}`)
			window.open(url, "Integrations | Syrinscape")
		},

		get playerInterfaceUrl() {
			return `${this.sessionIdUrl}/player/`
		},
	}
}

syrinscape.integration ??= createIntegration()

export const integration = syrinscape.integration
export default integration
